import React from 'react';
import './text-input.css';

import SimpleTextarea from './SimpleTextarea';

class TextArea extends React.Component{
  constructor(props){
    super(props);
  }

  render(){
    const onChange = this.props.onChange ? this.props.onChange : null;
    return(
      <div className="box-input">
          <div className="box-input--title">{this.props.title}</div>
          <div className="box-input--border">
            <div className="box-input--inner">
              <SimpleTextarea onChange={onChange} placeholder={this.props.placeholder} value={this.props.value} name={this.props.name} />
            </div>
          </div>
      </div>
    );
  }
}

export default TextArea;



// WEBPACK FOOTER //
// ./src/components/form/TextArea.js